export default __webpack_public_path__ + "static/media/authBackground.432af41a.svg";